/**
 * Created by mzietek on 2017-02-22.
 */

(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('HtmlWindowService', HtmlWindowService);


    function HtmlWindowService() {
        return {
            initResizeBehaviour : initResizeBehaviour
        };

        function initResizeBehaviour() {
            var funcDefined = defineResizeFunction(window);
            console.log('funcDefinied',funcDefined);
            if(funcDefined) {
                setDocumentReadyResizeInit();
            }
        };

        function defineResizeFunction(window) {
            if(!window.parent.resizeIframeHeight) {
                return false;
            }

            resizeIframeParentAssisted();
            return true;
        }

        function resizeIframeParentAssisted() {
            var selfHeight = $('body').height();
            try {
                window.parent.resizeIframeHeight(selfHeight + 75);
            } catch(err) {
                //Handle errors here
                if(window['console'] !== undefined) {
                    console.log(err);
                } else {
                    console.log = function() {};
                    console.log(err);
                }
            }
        };

        function setDocumentReadyResizeInit() {
            $(document).ready(function() {
                resizeIframeParentAssisted();

                $('.displayInParent').bind('click', function() {
                     displayInParent($(this).attr('href'));
                })
            });
        }
    }

})(angular);